import { takeLatest, put, call } from 'redux-saga/effects';

import { findAllEvolucaoAnimal } from '../service';
import {
  LIST_EVOLUCAO_ANIMAL,
  LIST_EVOLUCAO_ANIMAL_PENDING,
  LIST_EVOLUCAO_ANIMAL_SUCCESS,
  LIST_EVOLUCAO_ANIMAL_FAILURE
} from '../actionTypes';

function* sagaListAllEvolucaoAnimal(action) {
  yield put({ type: LIST_EVOLUCAO_ANIMAL_PENDING })

  try {
    const list = yield call(findAllEvolucaoAnimal)
    
    yield put({ type: LIST_EVOLUCAO_ANIMAL_SUCCESS, list: list })
  } catch (error) {

    yield put({ type: LIST_EVOLUCAO_ANIMAL_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListAllEvolucaoAnimal() {
  yield takeLatest(LIST_EVOLUCAO_ANIMAL, sagaListAllEvolucaoAnimal)
}